import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"card-header border-0 pt-5 pb-3\"><h2 class=\"card-title align-items-start flex-column\"><span class=\"card-label fw-boldest text-gray-800 fs-2\">Stock Report</span><span class=\"text-gray-600 fw-bold mt-2 fs-6\">Total 2,356 Items in the Stock</span></h2><div class=\"card-toolbar\"><div class=\"my-1 pe-6\"><label for=\"\">Category</label><select class=\"form-select form-select-sm form-select-solid fw-bolder w-125px\" data-control=\"select2\" data-placeholder=\"All Users\" data-hide-search=\"true\"><option value=\"1\" selected>Show All</option><option value=\"2\">Active users</option><option value=\"3\">Pending users</option></select></div><div class=\"my-1 pe-6\"><label for=\"\">Status</label><select class=\"form-select form-select-sm form-select-solid fw-bolder w-125px\" data-control=\"select2\" data-placeholder=\"All Users\" data-hide-search=\"true\"><option value=\"1\" selected>Show All</option><option value=\"2\">Active users</option><option value=\"3\">Pending users</option></select></div><div class=\"position-relative pe-6 my-1\"><label for=\"\"></label><button class=\"btn btn-sm btn-light mt-7\">View Stock</button></div></div></div>", 1)
const _hoisted_2 = { class: "card-body py-0" }
const _hoisted_3 = { class: "table-responsive" }
const _hoisted_4 = {
  class: "table align-middle table-row-bordered table-row-dashed gy-5",
  id: "kt_table_widget_1"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("tr", { class: "text-start text-gray-600 fw-boldest fs-5 text-uppercase" }, [
  /*#__PURE__*/_createElementVNode("th", { class: "min-w-100px text-center" }, "ITEM"),
  /*#__PURE__*/_createElementVNode("th", { class: "min-w-100px text-center" }, "PRODUCT ID"),
  /*#__PURE__*/_createElementVNode("th", { class: "min-w-100px text-center" }, "DATE ADDED"),
  /*#__PURE__*/_createElementVNode("th", { class: "min-w-100px text-center" }, "PRICE"),
  /*#__PURE__*/_createElementVNode("th", { class: "min-w-100px text-center" }, "STATUS"),
  /*#__PURE__*/_createElementVNode("th", { class: "text-end text-center" }, "QTY")
], -1)
const _hoisted_6 = { class: "text-end" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("td", { class: "pe-0 text-end" }, "290 PCS", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.widgetClasses, "card"])
  }, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("table", _hoisted_4, [
          _createElementVNode("tbody", null, [
            _hoisted_5,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, i) => {
              return (_openBlock(), _createElementBlock("tr", { key: i }, [
                _createElementVNode("td", null, _toDisplayString(item.name), 1),
                _createElementVNode("td", null, _toDisplayString(item.code), 1),
                _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(_ctx.newDate)), 1),
                _createElementVNode("td", _hoisted_6, _toDisplayString(item.code), 1),
                _createElementVNode("td", null, [
                  _createElementVNode("button", {
                    style: {"padding":"5px","width":"100px"},
                    class: _normalizeClass(_ctx.class2)
                  }, " In Stock ", 2)
                ]),
                _hoisted_7
              ]))
            }), 128))
          ])
        ])
      ])
    ])
  ], 2))
}